import { Box } from '@palmetto/palmetto-components';

import { Diffs } from './Diffs';
import EventBy from './EventBy';

const DISPLAY_FIELDS = [
  'minFicoScore',
  'ficoScoreErrorThreshold',
  'minFicoToRerun',
  'creditExpiryTerm',
  'yearsSinceLastBankruptcy',
  'maxAppsPerDay',
  'autoQualify',
  'multipleApplicantMinimumFico',
];

const SabalOrganizationUnderwritingSettingsUpdated = ({ event }: { event: any }) => {
  const prev = event.data?.previousUnderwritingSettings;
  const next = event.data?.newUnderwritingSettings;
  const isCreate = prev === null || prev === undefined;

  const diff = DISPLAY_FIELDS.reduce<Record<string, { from: any; to: any }>>((acc, key) => {
    if (prev?.[key] !== next?.[key]) {
      acc[key] = { from: prev?.[key] ?? '—', to: next?.[key] ?? '—' };
    }
    return acc;
  }, {});

  const action = isCreate ? 'created' : 'updated';
  const stateLabel = next?.state ? `, ${next.state}` : '';
  const programTypeLabel = event.data?.programType ? ` (${event.data.programType}${stateLabel})` : '';

  return (
    <Box display="block">
      <EventBy event={event} /> {action} underwriting settings{programTypeLabel}
      <Diffs diff={diff} hiddenProperties={[]} />
    </Box>
  );
};

export default SabalOrganizationUnderwritingSettingsUpdated;
